//
import PchProviderModel from "@/models/Purchase/PchProvider"

/**
 * This class describes a pch provider.
 *
 * @class      PchProvider (name)
 */
export default class PchProviderToList extends PchProviderModel {

    /**
     * { item_description }
     */
    static includes = []
}